import Message from '@talkdesk/cobalt-react-message'
import Flex from '@talkdesk/cobalt-react-flex'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import { Heading, Text } from '@talkdesk/cobalt-react-typography'
import Box from '@talkdesk/cobalt-react-box'

const sizeProps = /** @type {any} */ ({ size: 'small' })

/** @param {{ title?: any, message?: any }} props */
const Error = ({ title, message }) => {
  if (!message) {
    return null
  }

  return (
    <Box paddingY='3' width='100%'>
      <Message {...sizeProps} variation='error'>
        <Flex paddingX='3' paddingY='1' gap='3' alignY='center'>
          {title ? <Heading level='5'>{title}</Heading> : null}
          <IconWithProvider size='small' name='error' />
          <Text>{message}</Text>
        </Flex>
      </Message>
    </Box>
  )
}

export default Error
